<template>
  <div id="app">
    <PCNavBar v-if="!isMobile" :activeIndex="activeIndex" @update:activeIndex="setActiveIndex" />
    <MobileNavBar v-else :activeIndex="activeIndex" @update:activeIndex="setActiveIndex" />
    <router-view />
    <FooterPC v-if="!isMobile && $route.path !== '/download' && $route.path !== '/down'" />
    <FooterMobile v-else-if="$route.path !== '/download' && $route.path !== '/down'" />
  </div>
</template>

<script>
import PCNavBar from '@/views/com/navbar/navbarPC.vue'
import MobileNavBar from '@/views/com/navbar/navbarMobile.vue'
import FooterPC from '@/views/com/footer/footerPC.vue'
import FooterMobile from '@/views/com/footer/footerMobile.vue'


import responsive from '@/utils/responsive'

export default {
  components: { PCNavBar, MobileNavBar, FooterPC, FooterMobile },
  data() {
    return {
      activeIndex: 0,
      responsive
    }
  },
  computed: {
    isMobile() {
      return this.responsive.isMobile
    }
  },
  watch: {
    $route(to) {
      const map = {
        '/': 0,
        '/product': 1,
        '/price': 2,
        '/download': 3,
        '/down': 3,
        '/about': 4
      }
      this.activeIndex = map[to.path] !== undefined ? map[to.path] : 0
    }
  },
  methods: {
    setActiveIndex(index) {
      this.activeIndex = index
    }
  },
  created() {
    const map = {
      '/': 0,
      '/product': 1,
      '/price': 2,
      '/download': 3,
      '/down': 3,
      '/about': 4
    }
    this.activeIndex = map[this.$route.path] !== undefined ? map[this.$route.path] : 0
  }
}
</script>

<style>
#app {
  /* min-height: 100vh; */
  display: flex;
  flex-direction: column;
}
</style>
